import * as MarketingUser from '@/services/rest-api/lib/customer/marketing-user'
import * as IndustryCategory from '@/services/rest-api/lib/customer/industry-category'
import { TMS_MARKETING_USER_FILTER } from '@/helpers/tms-access'

async function getImmediateTypes() {
  const result = [
    {
      id: 'Immediate',
      name: 'Immediate',
    },
    {
      id: 'Non-Immediate',
      name: 'Non-Immediate',
    },
  ]

  return {
    metadata: {
      total_count: result.length,
      page: 1,
    },
    data: {
      paginated_result: result,
    },
  }
}

const customerInfoFields = [
  {
    name: 'name',
    label: 'Nama Pelanggan',
    placeholder: 'Nama Pelanggan',
    validation: 'required|max:255,length',
  },
  {
    name: 'mgm_immediate_type',
    label: 'Tipe Pelanggan',
    placeholder: 'Tipe Pelanggan',
    type: 'select-resourceful',
    optionsGetter: getImmediateTypes,
    getInitialObject: (obj) => obj?.mgm_immediate_type,
    optionLabelFn: ({ item }) => item.name,
    validation: 'required',
  },
  {
    name: 'email',
    label: 'Email',
    placeholder: 'Email',
    validation: 'bail|optional|email|max:255,length',
  },
  {
    name: 'marketing_user_id',
    type: 'select-resourceful',
    label: 'Karyawan Pemasaran',
    optionsGetter: MarketingUser.get(TMS_MARKETING_USER_FILTER),
    getInitialObject: (obj) => obj?.marketing_user,
    optionLabelFn: ({ item }) => item.name,
    placeholder: 'Karyawan Pemasaran',
  },
  {
    name: 'npwp',
    label: 'NPWP',
    placeholder: '__.___.___._-___.___',
    validation: 'max:20,length',
    mask: '00.000.000.0-000.000',
  },
  {
    name: 'industry_category_name',
    label: 'Kategori Industri',
    type: 'select-resourceful',
    optionsGetter: IndustryCategory.get,
    getInitialObject: (obj) => {
      if (obj?.industry_category?.name == '') return null
      return obj.industry_category
    },
    placeholder: 'Kategori Industri',
    trackBy: 'name',
    optionLabelFn: ({ item }) => item.name,
  },
  {
    name: 'phone_number',
    type: 'text',
    label: 'Nomor Whatsapp',
    placeholder: 'Masukkan nomor whatsapp',
  },
  {
    name: 'third_party_id',
    type: 'text',
    label: 'ID Referensi',
    placeholder: 'Masukkan id referensi',
    errorBehavior: 'live',
  },
]

export default customerInfoFields
